import React from "react";
import { Link } from "react-router-dom";

function PayCancel() {
  return (
    <div className="container-lg p-0 d-flex flex-column flex-sm-row justify-content-center align-items-center my-5">
      <div className="text-center">
        <img
          src="https://cdn-icons-png.flaticon.com/512/1828/1828665.png"
          alt="Payment Canceled"
          width="100"
          height="100"
          className="mb-4"
        />
        <h2 className="mb-3 text-danger">A fizetés megszakadt</h2>
        <p className="lead">
          Úgy tűnik, hogy a fizetési folyamat nem fejeződött be. Lehet, hogy megszakítottad vagy valami hiba történt.
        </p>
        <p>
          Ha szeretnéd, újra próbálhatod a fizetést, vagy visszatérhetsz a kosaradhoz.
        </p>
        <div className="d-flex justify-content-center gap-3 mt-4">
          <Link to="/basket" className="btn btn-home-primary">
            Vissza a kosárhoz
          </Link>
          <Link to="/" className="btn btn-outline-secondary">
            Vissza a főoldalra
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PayCancel;
